import { BAM, CredentialFactory, ImpersonateCredentials } from '@bam/sdk';
import { parseJwt } from '../utils/utils';

const sdkStateKey = 'impersonated_by_sdk';

export default ($bamApi: BAM) => ({
  async identifyWallet(secret, tenant) {
    if ($bamApi.tenant !== tenant) {
      $bamApi.tenant = tenant;
    }
    return (
      await $bamApi.tenantClient.post(`/websocket/v1/adhoc`, {
        secret
      })
    ).data;
  },
  async stopImpersonate() {
    const sdkState = localStorage.getItem(sdkStateKey);
    localStorage.removeItem(sdkStateKey);

    if (!sdkState) {
      $bamApi.logout();
      throw new Error('Trying to stop impersonation when there is no token');
    }

    // Restore the state of the SDK to the one before the impersonation
    // We cant just call the build method, as we need the event listeners defined in axios.ts
    const savedSdkState = JSON.parse(sdkState);
    const credentials = CredentialFactory.build(savedSdkState.credentials);

    $bamApi.authorize(credentials);
    await $bamApi.useOrganizer(savedSdkState.organizer);

    const tokenInfo = parseJwt($bamApi.getToken().token);
    return $bamApi.account.getUser({ id: tokenInfo.id });
  },

  async impersonate(userId: number, organizerId: string) {
    // Save the current state of the SDK
    localStorage.setItem(sdkStateKey, JSON.stringify($bamApi.serialize()));

    // Update the credentials
    const impersonateCredentials = new ImpersonateCredentials(
      $bamApi.getToken(),
      userId
    );
    await $bamApi.authorize(impersonateCredentials, organizerId);

    const tokenInfo = parseJwt($bamApi.getToken().token);
    return $bamApi.account.getUser({
      id: tokenInfo.id
    });
  }
});
